import React from 'react'
import FormInput from '../../../../../library/form/components/FormInput';
import FormButton from '../../../../../library/form/components/FormActionButton2';
import FormHHMMInput from '../../../../../library/form/components/FormHHMMInput';


const ProdTaskBomRow = (props) => {
    const { formObject, index, rowKey } = props;

        return (
            <ul className="uiDPEditLine">
                <li className="uiColumnCenter uiColumn50">
                    <span>{index}</span>
                </li>
                <li className="uiColumnCenter uiColumn150">
                    <FormInput formObject={formObject} rowKey={rowKey}
                        action={{ 
                            InputType: "ac", paramName: "processName", acMethod: "ProcessName", acDepCtrl: { dtId: "%dataList.valLDT" },
                            actionId: "refresh", actionParam: {actionType : "update"}
                        }} 
                        ></FormInput>
                </li>
                <li className="uiColumnCenter uiColumn150">
                    <FormInput formObject={formObject} rowKey={rowKey} 
                    action={{ InputType: "input", paramName: "taskComment", actionId: "refresh", actionParam: {actionType : "update"} }}
                    />
                </li>
                <li className="uiColumnCenter uiColumn90">
                    <FormHHMMInput formObject={formObject} rowKey={rowKey} style={{width:"100px"}}
                        action={{ InputType: "input", paramName: "estTime", actionId: "refresh", actionParam: {actionType : "update"} }}
                    />
                </li>
                <li className="uiColumnCenter uiColumn90">
                    <FormInput formObject={formObject} rowKey={rowKey} className="uiInput" action={{
                                InputType: "ac", paramName: "costFormula", actionId: "refresh", actionParam: {actionType : "update"},
                                acMethod: "CategoryDetail", acDepCtrl: { dparam: '%dataList.valLCat' }
                            }}
                    />
                </li>
                <li className="uiColumnCenter uiColumn60 uiActionBlock">
                    <FormButton formObject={formObject} rowKey={rowKey}
                        starIcon="clear"
                        onlyIcon={true}
                        tooltip="Delete"
                        starIconClassName="uiColorNegativeAction"
                        action={{ actionId: "del",  actionParam: {}, containerKey: "row" }}
                        className="" ></FormButton>
                </li>
            </ul>
        )
}

export default ProdTaskBomRow